import { render } from "./SlaveDataItem.vue?vue&type=template&id=633ad9b2"
import script from "./SlaveDataItem.vue?vue&type=script&lang=js"
export * from "./SlaveDataItem.vue?vue&type=script&lang=js"

import "./SlaveDataItem.vue?vue&type=style&index=0&id=633ad9b2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__